"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";

/**
 * The under-`lg` navigation: a plain `<details>` so the links are in the
 * HTML, keyed by the pathname so it remounts closed after a navigation —
 * a reader who picked a page does not land on it with the menu still open.
 */
export function DocsMobileNav({ summary, children }: { summary: ReactNode; children: ReactNode }) {
  const pathname = usePathname();
  return (
    <details key={pathname} className="mb-8 rounded-xl border border-border p-4 lg:hidden" data-testid="docs-nav-details">
      <summary className="cursor-pointer text-sm font-medium text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md">
        {summary}
      </summary>
      <div className="mt-4">{children}</div>
    </details>
  );
}
